'use client';

import { Button, Typography } from '@musinsa/mds';
import { twMerge } from 'tailwind-merge';

interface CtaButton {
  label: string;
  onClick: () => void;
  disabled?: boolean;
  /** submit 진행 중 스피너 — 중복 호출 방지(더블탭). (SID-4740) */
  loading?: boolean;
}

interface OptionSheetFooterProps {
  variant: 'single-cta' | 'dual-cta';
  /** 우측 / 단독 primary CTA */
  primary: CtaButton;
  /** variant='dual-cta' 일 때 좌측 secondary CTA (예: "상품 다시 선택" / "취소") */
  secondary?: Omit<CtaButton, 'disabled'>;
  className?: string;
}

/**
 * 시트 footer wrapper.
 * - border-t + padding + 듀얼/싱글 CTA + HomeIndicator (5×134 bar)
 * - propose 거절 / option 시트 양쪽에서 공통 사용
 */
export const OptionSheetFooter = ({
  variant,
  primary,
  secondary,
  className,
}: OptionSheetFooterProps) => (
  <div
    className={twMerge(
      'bg-white py-[12px]! px-[16px]! border-t border-[rgba(138,138,138,0.1)] safe-area-bottom',
      className,
    )}
  >
    <div className="flex gap-[8px]">
      {variant === 'dual-cta' && secondary && (
        <Typography size="14" weight="medium" asChild>
          <Button variant="secondary" size={44} onClick={secondary.onClick} className="flex-1">
            {secondary.label}
          </Button>
        </Typography>
      )}
      <Typography size="14" weight="medium" asChild>
        <Button
          variant="primary"
          size={44}
          disabled={primary.disabled}
          isLoading={primary.loading}
          onClick={primary.onClick}
          className="flex-1"
        >
          {primary.label}
        </Button>
      </Typography>
    </div>
  </div>
);
